<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="timeWindowUpdatePermission" id="page-user-edit">
		<vx-card>
			<time-window-edit-tab v-if="timeWindow !== null" :dataTimeWindow="timeWindow" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import TimeWindowEditTab from "./TimeWindowEditTab.vue";
import moduleTimeWindow from "@/store/time-window/moduleTimeWindow.js";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		TimeWindowEditTab,
		NotPermission,
	},
	data() {
		return {
			timeWindow: null,
		};
	},
	created() {
		if (!moduleTimeWindow.isRegistered) {
			this.$store.registerModule("moduleTimeWindow", moduleTimeWindow);
			moduleTimeWindow.isRegistered = true;
		}
		this.getTimeWindowById(parseInt(this.$route.params.id));
	},
	computed: {
		timeWindowUpdatePermission() {
			return this.$store.getters.checkPermission("TIME_WINDOW_U");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getTimeWindowById(timeWindowId) {
			this.openLoading();
			this.$store
				.dispatch("moduleTimeWindow/timeWindowFilter", {id: [timeWindowId]})
				.then((res) => {
					this.timeWindow = res.records[0];
					this.closeLoading();
					return res.records;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
